/**
 * Environment variable utilities
 * Provides access to runtime environment variables injected by Kubernetes
 */

interface RuntimeEnvironment {
    VITE_ENV: string;
    VITE_SKIP_AUTH: string;
    VITE_TEST_ONLY_ROLES: string;
    VITE_TEST_USER_NAME: string;
    VITE_TEST_USER_EMAIL: string;
    VITE_AZURE_CLIENT_ID: string;
    VITE_AZURE_TENANT_ID: string;
    VITE_REDIRECT_URI: string;
    VITE_POST_LOGOUT_REDIRECT_URI: string;
    VITE_API_SCOPES: string;
    VITE_BACKEND_URL: string;
    VITE_DATADOG_CLIENT_TOKEN: string;
    VITE_AZURE_GROUP_ADMIN: string;
    VITE_AZURE_GROUP_REGIEVOERDER: string;
    VITE_AZURE_GROUP_KLANTENSERVICE: string;
    VITE_AZURE_GROUP_RCB_TRANSVISION: string;
    VITE_AZURE_GROUP_RCB_DEWIT: string;
    VITE_AZURE_GROUP_SUPPORTCONSULTANT: string;
    VITE_AZURE_GROUP_VRIJWILLIGER: string;
    VITE_AZURE_GROUP_ALLEEN_LEZEN: string;

    [key: string]: string;
}

declare global {
    interface Window {
        RUNTIME_ENV?: RuntimeEnvironment;
    }
}

/**
 * Gets an environment variable at runtime from docker-entrypoint.sh, or from import.meta.env if running locally
 */
export const getEnv = (key: string): string => {
    const runtimeValue = window.RUNTIME_ENV?.[key];
    const viteValue = import.meta.env?.[key] as string | undefined;
    return runtimeValue ?? viteValue ?? "";
};

/**
 * Get a boolean environment variable value
 */
export const getBoolEnv = (key: string): boolean => {
    const value = getEnv(key);
    return value.toLowerCase() === "true";
};

export const isNotProduction = (): boolean => {
    return getEnv("VITE_ENV") !== "production";
};

export const isDev = (): boolean => {
    return getEnv("VITE_ENV") === "dev";
};

export default {
    isNotProduction,
    getEnv,
    getBoolEnv,
};
